module.exports = __webpack_public_path__ + "static/media/cotton-rag-paper.5edebfeb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cotton-rag-paper.jpg
// module id = 1052
// module chunks = 0